/**
 * Spinner.js
 *
 * A simple CSS animated loading spinner.
 *
 * Copyright (c) apploft. GmbH
 */

import React from 'react';
import './Spinner.css';

function Spinner() {
  return (
    <div className="centered">
      <div className="lds-ellipsis">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}

export default Spinner;
